export const dashboardSelector = (state) => state.dashboard;
